import { FC } from 'react';
import { AgentService } from 'components/AgentService';
import { memberInfoSelector } from '@doda/common/src/redux/features/memberInfo';
import { useAppSelector } from '@doda/common/src/redux/hooks';
import { useAgentService } from 'components/AgentService/hooks/useAgentService';
import { totalJobCountSelector } from 'redux/features/jobList';
import { useSelector } from 'react-redux';
import { AGENT_SERVICE_BASE_URL } from 'components/AgentService/constants';
import { PLPLINKLIST_JOBSEARCHLIST_UNDER } from '@doda/common/src/constants/seo';
import { SeoFooterLink } from 'components/SeoFooterLink';
import { useIsShowSeoFooterLink } from '@doda/common/src/hooks/jobSearchList/useIsShowSeoFooterLink';
import { RecommendList } from '../RecommendList';
import { PageProps } from '../../index.page';
import { JobContentLink } from '../jobContentLink';
import { Pagination } from '../Pagination';
import { PlpLinkList } from '../PlpLinkList';
import styles from '../../screens/index.module.scss';

/**
 * BodyFooterのProps
 * @param isShowPagination ページネーション表示判定フラグ
 * @param seoFooterLink SEOフッターリンク
 * @param similarKeywordList 類似キーワードリスト
 */
interface Props {
  isShowPagination: PageProps['isShowPagination'];
  seoFooterLink: PageProps['seoFooterLink'];
  similarKeywordList: PageProps['similarKeywordList'];
}

export const BodyFooter: FC<Props> = ({
  isShowPagination,
  seoFooterLink,
  similarKeywordList,
}) => {
  const totalJobCount = useSelector(totalJobCountSelector);
  const memberInfo = useAppSelector(memberInfoSelector);
  const loginStatus = memberInfo?.loginStatus ?? false;
  const { shouldShowAgentService } = useAgentService(memberInfo?.wtsrfl);
  const agentServiceUrl = totalJobCount
    ? `${AGENT_SERVICE_BASE_URL}&usrclk_searchList=PC-${loginStatus ? 'login' : 'logout'}JobSearchList_searchResultFooterAddedArea_agentServiceRegist`
    : AGENT_SERVICE_BASE_URL;

  const isShowSeoFooterLink = useIsShowSeoFooterLink(totalJobCount);

  return (
    <div>
      <PlpLinkList position={PLPLINKLIST_JOBSEARCHLIST_UNDER} />
      {isShowPagination && (
        <div className={styles.jobSearchList__pagination}>
          <Pagination />
        </div>
      )}
      <RecommendList similarKeywordList={similarKeywordList} />

      <JobContentLink />

      {shouldShowAgentService && (
        <div className={styles.jobSearchList__agentService}>
          <AgentService href={agentServiceUrl} />
        </div>
      )}
      <div className={styles['jobSearchList__seo-footer']}>
        {isShowSeoFooterLink && (
          <>
            {seoFooterLink.map(({ boxName, boxLinks }) => (
              <SeoFooterLink
                title={boxName}
                listItems={boxLinks}
                key={boxName}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};
